export enum View {
  List = 'list',
  Chart = 'chart-mobile',
  Visual = 'visual-mobile',
}

export const VIEW_LIST = View.List;
export const VIEW_CHART = View.Chart;
export const VIEW_VISUAL = View.Visual;
